export default {"src":"/_next/static/media/chevron-down.acf8079f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};